export const baseAgenticURL =  "https://bnlwe-af01-p-930838-unilevercom-webapp-01-bwa2huh4djcdepgd.westeurope-01.azurewebsites.net"
